<script setup>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import Helmet from '@/components/Helmet.vue'
import { useRouter, useRoute } from 'vue-router'

const router = useRouter()
const route = useRoute()

function goToContact() {
  if (route.path === '/') {
    // Si ya estás en la página principal, simplemente agregamos el hash
    router.replace({ hash: '#contact' })
  } else {
    // Si estás en otra ruta, redirige a la home con el hash
    router.push({ path: '/', hash: '#contact' })
  }
}
</script>



<template>
  <div>
    <Helmet title="Web programada vs Tienda Nube, Shopify, Wix y más: ¿qué conviene en 2025?" />
    <Header />

    <section class="blog-article">
      <h1>Diferencias entre una web hecha a medida y una con, Tienda Nube, Shopify o Wix</h1>
      <p class="article-summary">
        Exploramos las ventajas de una web 100% personalizada frente a soluciones prediseñadas. ¿Cuál conviene más a largo plazo?
      </p>

      <div class="article-meta">
        <span>Por Máximo Felipe Resi</span>
        <span class="date">28 de mayo de 2025</span>
      </div>

      <img
        src="../../public/img/codevsbuilder.png"
        alt="Web programada vs constructores de sitios web"
        title="Página web con código vs plataformas de creación de sitios web"
        class="article-image"
      />

      <div class="article-content">
        <p>
          A la hora de crear una página web, muchos emprendedores se enfrentan a una decisión: ¿usar plataformas como Wix o Shopify, o contratar un desarrollo web a medida?
        </p>

        <h2>✅ Ventajas de una web hecha a medida</h2>
        <ul>
          <li><strong>Velocidad y rendimiento:</strong> el código es limpio y optimizado, sin elementos innecesarios.</li>
          <li><strong>Diseño único:</strong> la web se adapta 100% a tu marca y no a una plantilla genérica.</li>
          <li><strong>Escalabilidad:</strong> podés agregar funcionalidades sin limitaciones de la plataforma.</li>
          <li><strong>Mejor SEO:</strong> el control completo del HTML permite optimizar para buscadores de forma avanzada.</li>
        </ul>

        <h2>⚠️ Limitaciones de Wix, Shopify y otras plataformas</h2>
        <ul>
          <li><strong>Código cerrado:</strong> no podés modificar en profundidad cómo funciona el sitio.</li>
          <li><strong>Dependencia total:</strong> si Wix cambia sus políticas o precios, estás atado.</li>
          <li><strong>Diseños repetidos:</strong> muchas páginas se ven iguales, lo cual afecta la percepción profesional.</li>
          <li><strong>SEO limitado:</strong> cuesta más posicionar bien por las restricciones del sistema.</li>
        </ul>

        <h2>💡 ¿Cuál conviene más?</h2>
        <p>
          Si estás comenzando y querés una solución rápida, Wix o Shopify pueden servirte. Pero si buscás diferenciarte, escalar tu negocio y lograr una presencia online profesional, una web hecha a medida es la mejor inversión.
        </p>

        <p>
          En <strong>Resi Corporation</strong> te ayudamos a construir un sitio moderno, optimizado y alineado con tus objetivos.
        </p>

        <p class="cta">
          ¿Querés una web personalizada para tu negocio?<br />
          <a @click.prevent="goToContact" href="#" class="cta-link">Contactanos y te asesoramos sin compromiso</a>
        </p>
      </div>
    </section>

    <Footer />
  </div>
</template>


<style scoped>
.blog-article {
  max-width: 900px;
  margin: 100px auto 50px auto;
  padding: 1rem;
  text-align: left;
}

h1 {
  font-size: 2.25rem;
  margin-bottom: 1rem;
  color: var(--title-color);
}

.article-summary {
  font-size: 1.125rem;
  color: var(--text-color);
  margin-bottom: 1.5rem;
}

.article-meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.875rem;
  color: #888;
  margin-bottom: 1.5rem;
}

.article-image {
  width: 100%;
  border-radius: 12px;
  margin-bottom: 2rem;
}

.article-content p {
  font-size: 1rem;
  line-height: 1.7;
  margin-bottom: 1rem;
}

.article-content h2 {
  font-size: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1rem;
  color: var(--title-color);
}

.article-content ul {
  padding-left: 1.5rem;
  margin-bottom: 1rem;
}

.article-content ul li {
  margin-bottom: 0.5rem;
  line-height: 1.5;
}

.cta {
  font-weight: bold;
  text-align: center;
  margin-top: 2.5rem;
  color: var(--title-color);
}

.cta-link {
  display: inline-block;
  margin-top: 1rem;
  background: var(--first-color);
  color: white;
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  text-decoration: none;
  transition: background 0.3s ease;
}

.cta-link:hover {
  background: red;
}
</style>
